import Spacer from "components/global/Spacer";
import styled from "styled-components";

const Wrapper = styled.div`
  margin: auto auto;
  padding: 2.4rem;
  width: 36rem;
  height: 32.9rem;

  .activity {
    margin: auto auto;
    text-align: center;

    h5 {
      font-weight: 700;
    }

    p {
      width: 23.5rem;
    }
  }
`;

const NoNotifications = () => {
  return (
    <Wrapper className="flexColumn alignCenter">
      <div className="activity">
        <h5>You don't have any notifications</h5>
        <Spacer y={1} />
        <p>Activity on your post and any reminder will appear here</p>
      </div>
    </Wrapper>
  );
};

export default NoNotifications;
